import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { OrderStatusPipe } from '../../pipes';
import { OrderStatus } from '../../enums';

@Component({
  selector: 'app-order-status',
  imports: [CommonModule, OrderStatusPipe],
  templateUrl: './order-status.component.html',
  styleUrl: './order-status.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrderStatusComponent {
  public readonly status = input.required<OrderStatus>();

  protected readonly cssClass = computed(() => {
    switch (this.status()) {
      case OrderStatus.New:
        return 'text-blue-600';

      case OrderStatus.Paid:
        return 'text-green-600';

      case OrderStatus.PartiallyCompleted:
        return 'text-lime-600';

      case OrderStatus.WaitingForPayment:
        return 'text-orange-500';

      case OrderStatus.Completed:
        return 'text-emerald-700';

      case OrderStatus.Pending:
        return 'text-yellow-500';

      case OrderStatus.Refunded:
        return 'text-indigo-600';

      case OrderStatus.PartiallyRefunded:
        return 'text-purple-700';

      case OrderStatus.Cancelled:
        return 'text-gray-500';

      default:
        return '';
    }
  });
}
